// extracted by mini-css-extract-plugin
export default {"container":"Qo-z","heading":"Ro-z","text":"So-z","info":"To-z","link":"Uo-z","fullMaxWidth":"Vo-z"};